import _ from 'lodash';
import { Reducer } from 'redux';
import {
  CitationPagesAction,
  GET_CITATION_INFORMATION,
  GET_CITATION_DETAILS,
  GET_PAYMENT_TEXT,
  GET_PAYMENT_ACCEPTED_TEXT,
  GET_PAYMENT_DECLINED_TEXT,
  GET_APPEAL_FINE_HEADER,
  GET_APPEAL_SENT,
  GET_MANAGE_CITATION_DETAILS,
  SET_CITATION_TITLE_NAME,
} from './actions';
import { LogoutAction, LOGOUT } from 'store/user/actions';

export interface CitationsPages {
  readonly id: number;
  readonly defaultFlag: boolean;
  readonly name: string;
  readonly page: string;
  readonly text: string;
  readonly citationtitleNames: any;
  readonly citationInformation?: SalesMessagePages;
  readonly citationDetails?: SalesMessagePages;
  readonly manageCitationDetails?: any;
  readonly paymentText?: SalesMessagePages;
  readonly paymentAcceptedText?: SalesMessagePages;
  readonly paymentDeclinedText?: SalesMessagePages;
  readonly appealFineHeader?: SalesMessagePages;
  readonly appealSent?: SalesMessagePages;
}

export const defaultState: CitationsPages = {
  id: 0,
  defaultFlag: false,
  name: '',
  page: '',
  text: '',
  citationtitleNames: undefined,
  citationInformation: undefined,
  citationDetails: undefined,
  manageCitationDetails: undefined,
  paymentAcceptedText: undefined,
  paymentDeclinedText: undefined,
  paymentText: undefined,
  appealFineHeader: undefined,
  appealSent: undefined,
};

export const reducer: Reducer<CitationsPages, CitationPagesAction | LogoutAction> = (state = defaultState, action) => {
  switch (action.type) {
    case GET_CITATION_INFORMATION:
      return {
        ...state,
        citationInformation: { ...action.payload[0] },
      };
    case GET_CITATION_DETAILS:
      return {
        ...state,
        citationDetails: { ...action.payload[0] },
      };
    case GET_MANAGE_CITATION_DETAILS:
      return {
        ...state,
        manageCitationDetails: { ...action.payload[0] },
      };
    case GET_PAYMENT_TEXT:
      return {
        ...state,
        paymentText: { ...action.payload[0] },
      };
    case GET_PAYMENT_ACCEPTED_TEXT:
      return {
        ...state,
        paymentAcceptedText: { ...action.payload[0] },
      };
    case GET_PAYMENT_DECLINED_TEXT:
      return {
        ...state,
        paymentDeclinedText: { ...action.payload[0] },
      };
    case GET_APPEAL_FINE_HEADER:
      return {
        ...state,
        appealFineHeader: { ...action.payload[0] },
      };
    case GET_APPEAL_SENT:
      return {
        ...state,
        appealSent: { ...action.payload[0] },
      };
    case SET_CITATION_TITLE_NAME:
      return {
        ...state,
        citationtitleNames: action.payload,
      };
    case LOGOUT:
      return defaultState;
    default:
      return state;
  }
};

export default reducer;
